import LinkButton from '@carvana/ds-link-button';
import cx from 'classnames';
import useModal from '@carvana/ds-modal';
import RatingStars from '@carvana/stc-rating-stars';

import {
  BottomContent,
  Container,
  StarsContainer,
  ReviewText,
  CustomerDetails,
  CustomerName,
  Date
} from './Review.styles';
import useAnalyticEvent from 'shared/hooks/useAnalyticEvent';
import type { Review as ReviewType } from 'api/strapi';

type ReviewCardProps = {
  expanded?: boolean;
  openModal?: () => void;
  review: ReviewType;
};

const ReviewCard = ({ expanded, openModal, review }: ReviewCardProps) => {
  const { recordActionClicked } = useAnalyticEvent();

  const handleReadMore = () => {
    recordActionClicked('Landing Page', 'Read full review');
    if (openModal) {
      openModal();
    }
  };

  return (
    <Container className={cx({ expanded })}>
      <StarsContainer>
        <RatingStars rating={review.rating} />
      </StarsContainer>
      <ReviewText className={cx({ expanded })}>
        {expanded ? review.wholeReview : review.blurb}
      </ReviewText>
      {!expanded && (
        <LinkButton onClick={handleReadMore} underline={false} size="sm">
          Read More
        </LinkButton>
      )}
      <BottomContent>
        <CustomerDetails>
          <CustomerName>{review.name}</CustomerName>
          &nbsp;from {review.state}
        </CustomerDetails>
        <Date>{review.date.replace(',', '.')}</Date>
      </BottomContent>
    </Container>
  );
};

type ReviewProps = {
  review: ReviewType;
};

const Review = ({ review }: ReviewProps) => {
  const { Modal, openModal } = useModal();
  const firstName = review.name?.trim().split(' ')[0] || 'Customer';
  return (
    <>
      <ReviewCard review={review} openModal={openModal} />
      <Modal divLine modalHeader={`${firstName}’s Review`}>
        <ReviewCard review={review} expanded />
      </Modal>
    </>
  );
};

export default Review;
